<template>
    <div class="paySet form">
        <el-form class="sellWayForm" :model="item" ref="sellWayForm" label-width="85px" :rules="rules">
            <el-form-item label="" prop="feetype" label-width="0">
                <el-radio :label="1" v-model="item.feetype" :disabled="isDisabled" @change="freeOrNofree">免费</el-radio>
                <el-radio :label="2" v-model="item.feetype" @change="freeOrNofree" :disabled="isDisabled">付费</el-radio>
                <el-radio :label="3" v-model="item.feetype" @change="freeOrNofree" :disabled="isDisabled">加密</el-radio>
            </el-form-item>
            <el-form-item class="priceBox" prop="price" label="商品价格" v-show="String(item.feetype) === '2'">
                <div class="price">
                    <el-input v-model.trim="item.saleprice" placeholder="请输入商品价格" :disabled="isDisabled"></el-input>
                    <span>元</span>
                </div>
            </el-form-item>
            <el-form-item class="projectPriceBox" prop="projectPrice" label="划线价格" v-show="String(item.feetype) === '2'">
                <div class="projectPrice">
                    <el-input v-model.trim="item.uprice" placeholder="请输入划线价格" :disabled="isDisabled"></el-input>
                    <span>元</span>
                </div>
            </el-form-item>
            <el-form-item class="priceBox" prop="price" label="设置密码" v-show="String(item.feetype) === '3'">
                <el-input v-model.trim="item.livepass" placeholder="设置密码" :disabled="isDisabled"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'payset',
        data() {
            // 检查商品价格
            let checkArticlePrice = (rule, value, callback) => {
                let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
                if (String(this.item.feetype) === '2') {
                    if (!this.item.saleprice) {
                        callback(new Error('请输入商品价格'))
                    } else if (!numRegular.test(this.item.saleprice)) {
                        callback(new Error('两位小数哦！'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            }
            // 检查划线价格
            let checkProjectPrice = (rule, value, callback) => {
                let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
                if (String(this.item.feetype) === '2') {
                    if (!this.item.uprice) {
                        callback()
                    } else if (!numRegular.test(this.item.uprice)) {
                        callback(new Error('两位小数哦！'))
                    } else if (this.item.uprice > 0 && parseFloat(this.item.uprice) <= parseFloat(this.item.saleprice)) {
                        callback(new Error('划线价格不能低于商品价格'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            }
            return {
                isDisabled: false,
                item: {
                    feetype: 1, // 售卖方式
                    uprice: '', // 划线价格
                    saleprice: '', // 销售价格
                    livepass:'' //密码
                },
                rules: {
                    price: [
                        {validator: checkArticlePrice, trigger: 'blur'}
                    ],
                    projectPrice: [
                        {validator: checkProjectPrice, trigger: 'blur'}
                    ],
                    feetype: [
                        {required: true, message: '请选择售卖方式', trigger: 'blur'}
                    ],
                    livepass:[
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                }
            }
        },
        props: [
            'tryRead','status'
        ],
        mounted(){
          if(this.status==10||this.status==100){
              this.isDisabled=true
          }
          console.log(this.status)
          console.log(this.isDisabled)
        },
        methods: {
            setDisabled() {
                this.isDisabled = true
            },
            freeOrNofree() {
                this.item.uprice = this.item.uprice
                this.item.saleprice = this.item.saleprice
                this.item.livepass = this.item.livepass
                this.$emit('changeWay', this.item)
            },
            setItem(){

            },
            // setItem(parameter) {
            //     this.item.feetype = parameter.feetype
            //     this.item.uprice = parameter.uprice
            //     this.item.saleprice = parameter.saleprice
            // },
        },
        computed: {
            ...mapGetters([
                'loading',
                'user',
                'domain'
            ])
        },
        // 'item.feetype': {
        //     handler(newFeetype, oldFeetype) {
        //         if (newFeetype === 2) {
        //             this.item.checkView.share.status = false
        //         } else if (newFeetype === 1 && this.tryRead === '1') {
        //             this.item.checkView.share.status = true
        //         }
        //         this.$emit('changeWay', newFeetype)
        //     }
        // },
    }
</script>
<style lang="scss">
    @import "~common/scss/base";
    .paySet{
        width: 750px;
        .sellWayForm{
            background: #F5F7FA;
            padding: 15px 24px;
            .share{
                .el-form-item__label::after{
                    content: "";
                }
            }
            .priceBox,.projectPrice{
                 display:flex;
                 .el-input{
                     width: 230px;
                 }
                 span{
                     margin-left: 14px;
                 }
             }
            .priceBox{
                margin: 10px 0 0 0;
                .el-form-item__label{
                    text-align: left;
                }
                .el-form-item__label::after{
                    content: "*";
                    color: #F56C6C;
                    margin-left: 4px;
                }
                .el-form-item__content{
                    margin: 0!important;
                }
            }
            .projectPriceBox{
                margin: 10px 0 0 0;
                .el-form-item__label{
                    margin-top: 15px;
                    text-align: left;
                }
                .projectPrice{
                    margin-top: 15px;
                }
            }
            .tips{
                margin-top: 20px;
                margin-left: 85px;
                color:#909399;
                a{
                    color: #409EFF;
                }
            }
            .shareTips{
                color: #909399;
                margin-left: 10px;
            }
            .el-form-item__label{
                margin-left: 0!important;
            }
            .reduceMg{
                .el-form-item__label{
                    width: 0!important;
                }
                .el-form-item__content{
                    margin-left: 0 !important;
                }
            }
            .slider{
                .el-form-item__content{
                    width: 40px !important;
                }
            }
            .discountsTime{
                .el-form-item__content{
                    width: 222px !important;
                }
            }
            .el-form-item__content{
                margin-right: 10px;
            }
        }
    }
    .form{
        margin-top: 0!important;
    }
</style>
